$(document).ready(function() {
  $('.js-slider-header').on('click', function() {
    $('.js-slider-header').removeClass("coffee-active");
    $(this).addClass("coffee-active");

    const pos = $(this).closest(".header-wrapper").data("number");
    console.log(pos);

    const windowWidth = window.innerWidth;
    const targetScrollPosition = windowWidth * (pos - 1)

    $('#coffee-content-wrapper').animate({
      scrollLeft: targetScrollPosition
    }, 500); 
  });
});
